"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
const iconoir_react_1 = require("iconoir-react");
// import app components
const sidebar_1 = __importDefault(require("../sidebar"));
const theme_1 = require("../../../theme");
const Layout = (props) => {
    const { sidebarLeft, sidebarLeftWidth = "md", sidebarLeftSx = {}, sidebarRight, sidebarRightWidth = "md", sidebarRightSx = {}, children, } = props;
    const theme = (0, styles_1.useTheme)();
    const isMobile = (0, material_1.useMediaQuery)(theme.breakpoints.down("lg"));
    const [openLeft, setOpenLeft] = (0, react_1.useState)(false);
    const [openRight, setOpenRight] = (0, react_1.useState)(false);
    const handleClickLeft = () => {
        setOpenLeft(true);
    };
    const handleClickRight = () => {
        setOpenRight(true);
    };
    const handleClose = () => {
        setOpenLeft(false);
        setOpenRight(false);
    };
    const getWidth = (width) => {
        switch (width) {
            case "sm":
                return `${theme_1.SIDEBAR_WIDTH - theme_1.NAV_WIDTH}px`;
            case "md":
                return `${theme_1.SIDEBAR_WIDTH}px`;
            case "lg":
                return `${theme_1.SIDEBAR_WIDTH + theme_1.NAV_WIDTH}px`;
        }
    };
    const getGridTemplateColumns = () => {
        const columns = ["auto"];
        if (sidebarLeft) {
            columns.unshift(getWidth(sidebarLeftWidth));
        }
        if (sidebarRight) {
            columns.push(getWidth(sidebarRightWidth));
        }
        return columns.join(" ");
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Box, { sx: {
                display: { lg: "inline-grid" },
                gridTemplateColumns: { lg: getGridTemplateColumns() },
                width: "100%",
                p: { xs: sidebarLeft || sidebarRight ? 2 : 0, lg: 0 },
            } },
            isMobile && (sidebarRight || sidebarLeft) && (react_1.default.createElement(material_1.Box, { sx: { width: "100%", display: "flex", justifyContent: "flex-end" } },
                react_1.default.createElement(material_1.Stack, { direction: "row", spacing: 2, sx: { mb: 2 } },
                    sidebarLeft && (react_1.default.createElement(material_1.IconButton, { onClick: handleClickLeft, sx: { background: theme_1.colors.secondary[700] } },
                        react_1.default.createElement(iconoir_react_1.SidebarExpand, { style: { fontSize: "0.75rem", color: theme_1.colors.icons[700] } }))),
                    sidebarRight && (react_1.default.createElement(material_1.IconButton, { onClick: handleClickRight, sx: { background: theme_1.colors.secondary[700] } },
                        react_1.default.createElement(iconoir_react_1.SidebarExpand, { style: { fontSize: "0.75rem", color: theme_1.colors.icons[700] } })))))),
            sidebarLeft && (react_1.default.createElement(sidebar_1.default, { align: "left", sidebarWidth: sidebarLeftWidth, sx: {
                    ...(isMobile && {
                        transform: openLeft ? "translateX(0)" : "translateX(-100%)",
                        pt: 3,
                        pb: `${theme_1.NAV_MOBILE_HEIGHT}px`,
                    }),
                    ...sidebarLeftSx,
                } },
                sidebarLeft,
                isMobile && (react_1.default.createElement(material_1.IconButton, { onClick: handleClose, sx: { position: "absolute", top: 5, right: 5 } },
                    react_1.default.createElement(iconoir_react_1.Cancel, { style: { fontSize: "0.9rem", color: theme_1.colors.icons[700] } }))))),
            react_1.default.createElement(material_1.Box, { sx: {
                    display: "flex",
                    flexDirection: "column",
                    ...(!isMobile && { justifyContent: "space-between", overflow: "hidden" }),
                } }, children),
            sidebarRight && (react_1.default.createElement(sidebar_1.default, { align: "right", sidebarWidth: sidebarRightWidth, sx: {
                    ...(isMobile && {
                        transform: openRight ? "translateX(0)" : "translateX(100%)",
                        pt: 3,
                        pb: `${theme_1.NAV_MOBILE_HEIGHT}px`,
                    }),
                    ...sidebarRightSx,
                } },
                sidebarRight,
                isMobile && (react_1.default.createElement(material_1.IconButton, { onClick: handleClose, sx: { position: "absolute", top: 5, left: 5 } },
                    react_1.default.createElement(iconoir_react_1.Cancel, { style: { fontSize: "0.9rem", color: theme_1.colors.icons[700] } })))))),
        react_1.default.createElement(material_1.Backdrop, { sx: { zIndex: 1195 }, open: (openLeft && !!sidebarLeft) || (openRight && !!sidebarRight), onClick: handleClose })));
};
exports.default = Layout;
